import React from 'react';
import { useNavigate } from 'react-router-dom';

import classes from './JourneyProgress.module.scss';

interface Props {
    progress: number;
    step: number;
    children: React.ReactNode;
    first?: boolean;
}

function JourneyStep({ step, progress, children }: Props) {
    const navigate = useNavigate();

    const getClass = (el: string) => {
        if (step === progress) {
            return el === 'number' ? classes.current_number : classes.current_label;
        } else if (step > progress) {
            return el === 'number' ? classes.active_number : classes.active_label;
        } else {
            return '';
        }
    };

    const commonClasses = [classes.journeyStep].join(' ');

    /**
     * Method that navigates a user back to a step in the booking journey, uses step and progress props
     */
    const goTo = () => {
        if (step > progress && progress === 1) {
            navigate('/');
        }

        if (step > progress && progress === 2) {
            if (window.rapidstor_settings.app_config.pages.storageType) {
                navigate('/unit-listing');
            } else {
                navigate('/');
            }
        }
    };

    return (
        <div className={`${commonClasses}`} onClick={goTo}>
            <div className={`${classes.number} ${getClass('number')}`}>{progress}</div>
            <div className={`${classes.label} ${getClass('label')}`}>{children}</div>
        </div>
    );
}

export default JourneyStep;
